import { render, staticRenderFns } from "./BusinessesUnitsTable.vue?vue&type=template&id=2df680b0&scoped=true&"
import script from "./BusinessesUnitsTable.vue?vue&type=script&lang=js&"
export * from "./BusinessesUnitsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df680b0",
  null
  
)

export default component.exports